export default __webpack_public_path__ + "static/media/viewProfile.a861b2c8.png";